export default __webpack_public_path__ + "static/media/download.a49923d2.png";